import { Card, Text, Title } from "@mantine/core";

import NormalDistChartSectioned from "@components/test_entry/charts/NormalDistChartSectioned";
import React from "react";

export interface DyslexiaNormativeGraphProps {
  percentile: number;
}

const DyslexiaNormativeGraph: React.FC<DyslexiaNormativeGraphProps> = ({ percentile }) => {
  return (
    <Card withBorder radius="md" shadow="md" p="md" h="100%">
      <Card.Section px="md" pb="lg">
        <Title order={4} mb="sm" mt="sm">
          Normative Reading Performance Graph
        </Title>
      </Card.Section>
      <NormalDistChartSectioned
        referenceLines={[
          {
            x: percentile,
            label: `${percentile}%`,
            labelPosition: "top",
            color: "blue.7",
            isFront: true,
            strokeDasharray: "3 3",
          },
        ]}
      />
      <Text mt="sm">
        {`The graph shows that the reading performance of the individual is at `}
        <strong> {`percentile ${percentile}`}</strong>
        {` compared to the normative data.`}
      </Text>
    </Card>
  );
};

export default DyslexiaNormativeGraph;
